<template>
  <rabbey-top-menu />
</template>

<script>
export default {
  name: "InternalRequests"
};
</script>
